<div class="margin-vertical-20" *ngIf="showFundPerformanceLink">
	<span class="text-condensed-16" dcrHTMLKey="VIEW_FUND_PERFORMANCE_LINK_PRE"> Full details regarding fund performance can be found </span>
	<a
		class="text-condensed-16-bold"
		target="_blank"
		[routerLink]="[appPaths.FUND_PERFORMANCE]"
		[queryParams]="{ familyId: familyId, groupId: groupId }"
		dcrHTMLKey="VIEW_FUND_PERFORMANCE_LINK"
		[attr.data-link-event]="'family overview:view fund performance:' + familyId | analyticEventEvaluatorPipe"
	>
		here
	</a>
</div>
